"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const moment_1 = __importDefault(require("moment"));
require("./notificationItem.scss");
const react_redux_1 = require("react-redux");
require("./notificationItem.scss");
const dropdownIcon_1 = __importDefault(require("../../../../svgIcons/dropdownIcon"));
const notificationCenterSlice_1 = require("../../../../redux/slices/notificationCenterSlice");
const NotificationItem = (props) => {
    const { notification, notification: { read, message, created_at, data } } = props;
    const unread = !read;
    const handleClick = (notification) => {
        var _a;
        const url = (_a = notification.data) === null || _a === void 0 ? void 0 : _a.url;
        if (url) {
            return window.location.href = url;
        }
        return false;
    };
    const formatDate = (date) => {
        const currentTime = moment_1.default();
        const itemDate = moment_1.default(date);
        if (currentTime.diff(itemDate, 'h') > 24) {
            return itemDate.format("MM/DD/YYYY");
        }
        return itemDate.fromNow();
    };
    return (react_1.default.createElement("div", { className: `notification-item ${(data === null || data === void 0 ? void 0 : data.url) ? 'clickable' : ''}`, onClick: () => handleClick(notification) },
        react_1.default.createElement("div", { className: "notification-row" },
            react_1.default.createElement("div", { className: "notification-content" },
                react_1.default.createElement("div", { className: "notification-message" },
                    unread && react_1.default.createElement("span", { className: "unread-sign" }),
                    react_1.default.createElement("span", { dangerouslySetInnerHTML: { __html: message } })),
                react_1.default.createElement("div", { className: `notification-date ${unread ? 'date-active' : 'date'}` }, formatDate(created_at))),
            (data === null || data === void 0 ? void 0 : data.url) && react_1.default.createElement("span", { className: "notification-arrow" },
                react_1.default.createElement(dropdownIcon_1.default, { fill: unread ? "#2EA0DC" : "#afafb8" })))));
};
const mapDispatchToProps = (dispatch) => {
    return {
        markAsRead: (data) => dispatch(notificationCenterSlice_1.markAsRead(data))
    };
};
exports.default = react_redux_1.connect(null, mapDispatchToProps)(NotificationItem);
